// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3kB8j","noInteraction":"EventWrapper_noInteraction__1tbjI","pointerPassthrough":"EventWrapper_pointerPassthrough__1ZKla"};